import { IBrandByPos, IBrandBySubretail } from "../../models/dto/agendaApi/IBrandDto";
import * as ApiWithToken from "../callApiWithToken";

const brandsService = {
    getBrands: async function(){
        return  ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API +  `Brands/GetBrands`);
    },
    getBrandsBySubretail: async function(brandId: number, languageId: number){
        return  ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API +  `Brands/GetBrandsBySubretail?subretailId=${brandId}&languageId=${languageId}`);
    },
    getBrandsByPos: async function(posCode: string, languageId: number){
        return  ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API +  `Brands/GetBrandsByPos?posCode=${posCode}&languageId=${languageId}`);
    },
    postBrandByPos: async function (brandPosIn: IBrandByPos) {
        return ApiWithToken.postApi(process.env.REACT_APP_SURVEY_API + `Brands/CreateBrandFilterByPos`, brandPosIn);
    },
    postBrandBySubretail: async function (brandSubretailIn: IBrandBySubretail) {
        return ApiWithToken.postApi(process.env.REACT_APP_SURVEY_API + `Brands/CreateBrandFilterBySubretail`, brandSubretailIn);
    },
    deleteBrandByPos:async function(brandId:number, posCode:string){
        return ApiWithToken.deleteApi(process.env.REACT_APP_SURVEY_API + `Brands/DeleteBrandFilterByPos?brandId=${brandId}&posCode=${posCode}`);
    },
    deleteBrandBySubretail:async function(brandId:number, subretailId:number){
        return ApiWithToken.deleteApi(process.env.REACT_APP_SURVEY_API + `Brands/DeleteBrandFilterBySubretail?brandId=${brandId}&subretailId=${subretailId}`);
    }
    
}
export default brandsService;
